import { render } from "./NotificationDialog.vue?vue&type=template&id=5c29945e&scoped=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&lang=js"

import "./NotificationDialog.vue?vue&type=style&index=0&id=5c29945e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c29945e"]])

export default __exports__